import { createAsyncAction } from "../actionCreators";
import { API, CustomField, Space } from "@thenounproject/lingo-core";

type Args = {
  spaceId: Space["id"];
  field: Partial<CustomField>;
};

const [useCreateCustomField, createCustomField] = createAsyncAction(
  "fields/createCustomField",
  async ({ spaceId, field }: Args) => {
    const res = await API.call<{ field: number }>({
      endpoint: `/spaces/${spaceId}/fields`,
      method: "POST",
      data: field,
    });
    return { ...res, result: res.result.field };
  }
);

export default useCreateCustomField;
export { createCustomField };
